import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Wraps a route so only CEO users can render it. Non-CEO authenticated users
 * are redirected to /dashboard. Unauthenticated users are redirected to /signin.
 */
export default function CeoRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/signin" replace />;
  if (user.role !== 'CEO') return <Navigate to="/dashboard" replace />;
  return children;
}
